import { LinkRegistrationModelKo } from 'Content/ts/Models/Account/LinkRegistrationModel';

import * as localisationHelper from 'localisationHelper';
import * as passwordPolicyValidator from 'passwordPolicyValidator';
import * as ko from 'knockout';

import 'knockout.validation';

export class LinkRegistrationModelKoValidated extends LinkRegistrationModelKo {
    validationErrors: KnockoutValidationErrors;
    isValid: KnockoutComputed<boolean>;

    constructor() {
        super();

        this.Email.extend({
            email: {
                params: true,
                message: localisationHelper.getString('AccountResources', 'Register_Validation_EmailValid')
            },
            required: {
                params: true,
                message: localisationHelper.getString('AccountResources', 'Register_Validation_EmailRequired')
            },
            maxLength: {
                params: 150,
                message: localisationHelper.getString('AccountResources', 'Register_Validation_EmailLength')
            }
        });
        this.Password.extend({
            required: {
                params: true,
                message: localisationHelper.getString('AccountResources', 'Register_Validation_PasswordRequired')
            },
            validation: {
                async: true,
                validator: function (val: string, params: any, callback: Function) {
                    if (val != null) {
                        passwordPolicyValidator.validatePassword(val)
                            .then(function (response) {
                                callback(response);
                            });
                    }
                    else { return true; }
                },
                message: localisationHelper.getString('AccountResources', 'PasswordPolicyPrompt')
            }
        });
        this.ConfirmPassword.extend({
            validation: {
                validator: function (val: string, password: KnockoutObservable<string>) {
                    if (val != null && val === ko.unwrap(password)) {
                        return true;
                    }
                    return false;
                },
                message: localisationHelper.getString('AccountResources', 'Register_Validation_PasswordMismatch'),
                params: this.Password
            }
        });

        this.validationErrors = ko.validation.group({ Email: this.Email, Password: this.Password, ConfirmPassword: this.ConfirmPassword });
        this.isValid = ko.computed(() => this.validationErrors().length === 0 );
    }
}